import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment-timezone';
import Select from 'react-select';
import NexhealthAuthorization from './Nexhealth';
import Cloud9Authorization from './Cloud9';
import DenticonAuthorization from './Denticon';
import DentrixAscendAuthorization from './DentrixAscend';
import OpendentalAuthorization from './OpenDental';

import BookingSoftwares, {
  DENTRIX,
  EAGLESOFT,
  NEXHEALTH,
  DENTICON,
  CLOUD9,
  DENTRIX_ASCEND,
  OPEN_DENTAL
} from '../../assets/BookingSoftwares';
import TimeZone, { TIMEZONE_PST } from '../../assets/TimeZone';
import { DENTAL } from '../../assets/Domains';

import utils from '../../lib/utils';

import './index.scss';

export default class NonIntegratedSoftwareAuthorization extends React.Component {
  constructor(props) {
    super(props);

    const timeZoneGuess = moment.tz.guess();
    let defaultTimeZone = TIMEZONE_PST;

    for (let i = 0, l = TimeZone.length; i < l; i += 1) {
      if (timeZoneGuess === TimeZone[i].value) {
        defaultTimeZone = TimeZone[i].value;
        break;
      }
    }

    let siteLink = this.props.softwares.info.URL;

    if (!siteLink) {
      if (this.props.softwares.selectedSoftware === DENTRIX) {
        siteLink = 'https://live.dentrixascend.com/login';
      } else if (this.props.softwares.selectedSoftware === EAGLESOFT) {
        siteLink = 'http://patterson.eaglesoft.net';
      }
    }

    const { business, softwares } = this.props;
    let studioName = '';

    if (softwares && softwares.info.STUDIO_NAME) {
      studioName = softwares.info.STUDIO_NAME;
    } else if (business && business.info) {
      studioName = business.info.BUSINESS_NAME
        ? business.info.BUSINESS_NAME
        : '';
    }

    this.state = {
      otherUsername: this.props.softwares.otherUsername,
      otherPassword: this.props.softwares.otherPassword,
      studio_name: studioName,
      studio_address: this.props.softwares.info.STUDIO_LOCATION,
      timezone: this.props.business.info.TIMEZONE || defaultTimeZone,
      site_link: siteLink,
      accountName: this.props.softwares.info.accountName,
      bookingSoftware: '',
      otherBookingSoftware: '',
      nexHealthSelected:false,
      cloud9Selected: false,
      opendentalSelected: false,
      denticonSelected:false,
      dentrixAscendSelected:false,
      hasError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onTimezoneChange = this.onTimezoneChange.bind(this);
    this.onBookingSoftwareChange = this.onBookingSoftwareChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
    this.nexHealthBackClick = this.nexHealthBackClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const newState = {};

    if (
      typeof nextProps.softwares.isRequested === 'boolean' &&
      nextProps.softwares.isRequested === false
    ) {
      newState.hasError = true;
    } else if (
      typeof nextProps.softwares.isRequested === 'boolean' &&
      nextProps.softwares.isRequested === true
    ) {
      newState.isSaving = false;
    }

    if (
      !this.state.studio_name &&
      nextProps.business.info &&
      nextProps.business.info.BUSINESS_NAME
    ) {
      newState.studio_name = nextProps.business.info.BUSINESS_NAME;
    }

    this.setState(newState);
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onTimezoneChange(timezone) {
    this.setState({
      timezone: timezone ? timezone.value : '',
    });
  }

  onBookingSoftwareChange(bookingSoftware) {
    this.setState({
      bookingSoftware: bookingSoftware ? bookingSoftware.value : '',
    });
  }

  onNextButtonClick() {
    const { currentDomain } = this.props;
    const { bookingSoftware, otherBookingSoftware } = this.state;

    const data = {
      username: this.state.otherUsername,
      password: this.state.otherPassword,
      studio_name: this.state.studio_name,
      studio_address: this.state.studio_address,
      site_link: this.state.site_link,
      timezone: this.state.timezone,
      accountName: this.state.accountName,
    };

    if (bookingSoftware === 'NEXHEALTH'){
      console.log("NEXHEALTH selected")
      this.setState({
        nexHealthSelected:true,
      })

      this.props.selectSoftware({
        software: this.state.bookingSoftware,
        isIntegrated: true,
      });
    } else if (bookingSoftware === 'CLOUD9'){
       console.log("CLOUD9 selected")
       this.setState({
         cloud9Selected:true,
       })

       this.props.selectSoftware({
         software: this.state.bookingSoftware,
         isIntegrated: true,
       });
    } else if (bookingSoftware === 'DENTICON'){
     console.log("DENTICON selected")
     this.setState({
       denticonSelected:true,
     })

     this.props.selectSoftware({
       software: this.state.bookingSoftware,
       isIntegrated: true,
     });
   } else if (bookingSoftware === 'DENTRIX_ASCEND'){
     console.log("DENTRIX_ASCEND selected")
     this.setState({
       dentrixAscendSelected:true,
     })

     this.props.selectSoftware({
       software: this.state.bookingSoftware,
       isIntegrated: true,
     });
    } else if (bookingSoftware === 'OPEN_DENTAL') {
      console.log("DENTRIX_ASCEND selected")
      this.setState({
        opendentalSelected: true,
      })

      this.props.selectSoftware({
        software: this.state.bookingSoftware,
        isIntegrated: true,
      });
    }

    else{
    // Only for dental domain
      if (currentDomain === DENTAL) {
        data.booking_sw =
          bookingSoftware === 'ADDNEW' ? otherBookingSoftware : bookingSoftware;
      }

      if (this.validate(data)) {
        this.setState(
          {
            isSaving: true,
          },
          () => {
            if (currentDomain === DENTAL) {
              data.booking_sw = bookingSoftware === 'NONE' ? '' : bookingSoftware;
            }

            this.props.postBookingSoftwareRequest(data);
          },
        );
      }
    }
  }

  validate(data) {
    const { currentDomain } = this.props;

    const newState = {
      invalidURLError: false,
      mandatoryFieldBlankError: false,
    };

    let isValid = true;

    if (currentDomain === DENTAL) {
      // Only Studio name, address, and timezone are required for DENTAL domain
      if (
        !data.studio_name ||
        !data.studio_address ||
        !data.timezone ||
        !data.booking_sw
      ) {
        newState.mandatoryFieldBlankError = true;

        isValid = false;
      }
    } else {
      // Validate all parameters
      if (
        !data.username ||
        !data.password ||
        !data.studio_name ||
        !data.studio_address ||
        !data.site_link ||
        !data.timezone
      ) {
        newState.mandatoryFieldBlankError = true;

        isValid = false;
      }

      // Validate email
      if (!utils.isValidURL(data.site_link)) {
        newState.invalidURLError = true;

        isValid = false;
      }
    }

    this.setState(newState);

    return isValid;
  }

  nexHealthBackClick() {
    this.setState({
      nexHealthSelected:false,
      cloud9Selected:false,
      opendentalSelected: false,
      denticonSelected:false,
      dentrixAscendSelected:false,
    })
  }

  render() {
    const { isSaving, nexHealthSelected, denticonSelected, cloud9Selected, dentrixAscendSelected, opendentalSelected, timezone } = this.state;
    const { currentDomain } = this.props;
    const isSwConnected =
      this.props.dashboard.tasksStatus.bookingSW_connect === 'completed';
    const bookingSoftware = this.props.softwares.selectedSoftware;
    const bookingSoftwaresList = Object.keys(BookingSoftwares)
      .map((key) => {
        return BookingSoftwares[key];
      })
      .filter((item) => {
        return item.type.indexOf(currentDomain) !== -1;
      });

    bookingSoftwaresList.push({ label: 'None', value: 'NONE' });
    bookingSoftwaresList.push({ label: '+ Add New', value: 'ADDNEW' });

    console.log("STATE", this.state)
    const enableNextButtonForBSWs = [NEXHEALTH, DENTICON, CLOUD9, DENTRIX_ASCEND, OPEN_DENTAL];

    if(nexHealthSelected){
      console.log("loading NexhealthAuthorization screen")
      return(
        <div className="card">
          <div className="card__content">
            <div className="connect-booking-software__card__content">
              <NexhealthAuthorization {...this.props} onBackClick={this.nexHealthBackClick}/>
            </div>
          </div>
        </div>
      );
    }
    else if (cloud9Selected) {
      console.log("loading Cloud9Authorization screen")
      return(
        <div className="card">
          <div className="card__content">
            <div className="connect-booking-software__card__content">
              <Cloud9Authorization {...this.props} onBackClick={this.nexHealthBackClick}/>
            </div>
          </div>
        </div>
      );
    } else if (opendentalSelected) {
      console.log("loading OpenDentalAuthorization screen")
      return (
        <div className="card">
          <div className="card__content">
            <div className="connect-booking-software__card__content">
              <OpendentalAuthorization {...this.props} onBackClick={this.nexHealthBackClick} zone_id={timezone}/>
            </div>
          </div>
        </div>
      );
    } else if (denticonSelected){
    console.log("loading DenticonAuthorization screen")
          return(
            <div className="card">
              <div className="card__content">
                <div className="connect-booking-software__card__content">
                  <DenticonAuthorization {...this.props} onBackClick={this.nexHealthBackClick}/>
                </div>
              </div>
            </div>
          );
    }
    else if (dentrixAscendSelected){
    console.log("loading DentrixAscendAuthorization screen")
          return(
            <div className="card">
              <div className="card__content">
                <div className="connect-booking-software__card__content">
                  <DentrixAscendAuthorization {...this.props} onBackClick={this.nexHealthBackClick}/>
                </div>
              </div>
            </div>
          );
    }
    else {
      console.log("loading nonintegrated screen", this.props)
      return (
        <div className="authorize-access">
          <form className="authorize-access__form">
            {this.state.hasError ? (
              <p className="authorize-access__error">
                <i className="material-icons" aria-hidden="true">error</i>
                Sorry, the credentials you have provided are either already in use
                or invalid!
              </p>
            ) : (
              undefined
            )}
            {this.state.mandatoryFieldBlankError ? (
              <p className="authorize-access__error">
                <i className="material-icons" aria-hidden="true">error</i>
                Fields marked in red are mandatory!
              </p>
            ) : (
              undefined
            )}
            {this.state.invalidURLError ? (
              <p className="authorize-access__error">
                <i className="material-icons" aria-hidden="true">error</i>
                Booking software URL is invalid!
              </p>
            ) : (
              undefined
            )}
            {isSwConnected ? (
              <p className="authorize-access__success">
                <i className="material-icons" aria-hidden="true">check_circle</i>
                Your booking software details are already verified
              </p>
            ) : (
              undefined
            )}
            {isSwConnected ? (
              <p className="authorize-access__success">
                Please email us at support@truelark.com if you need to change any
                of the information below
              </p>
            ) : (
              undefined
            )}
            <section className="authorize-access__bz-details">
              <p className="authorize-access__text">
                Please provide the following details about your business
              </p>
              <div className="authorize-access__form__row form-group">
                <p className="form-group__heading">
                  {currentDomain === DENTAL ? 'Practice Name' : 'Business Name'}
                </p>
                <input
                  type="text"
                  name="studio_name"
                  className={classnames({
                    'has-error':
                      this.state.mandatoryFieldBlankError &&
                      !this.state.studio_name,
                  })}
                  value={this.state.studio_name}
                  onChange={this.onInputChange}
                  autoComplete="false"
                  disabled={isSwConnected}
                />
              </div>

              {currentDomain === DENTAL ? null : (
                <div className="authorize-access__form__row form-group">
                  <p className="form-group__heading">Account Name (if any)</p>
                  <input
                    type="text"
                    name="accountName"
                    value={this.state.accountName}
                    onChange={this.onInputChange}
                    autoComplete="false"
                    disabled={isSwConnected}
                  />
                </div>
              )}

              <div className="authorize-access__form__row form-group">
                <p className="form-group__heading">Address</p>
                <input
                  type="text"
                  name="studio_address"
                  className={classnames({
                    'has-error':
                      this.state.mandatoryFieldBlankError &&
                      !this.state.studio_address,
                  })}
                  value={this.state.studio_address}
                  onChange={this.onInputChange}
                  autoComplete="false"
                  disabled={isSwConnected}
                />
              </div>

              <div className="authorize-access__form__row form-group">
                <p className="form-group__heading">Timezone</p>
                <Select
                  value={TimeZone.filter(
                    (option) => option.value === this.state.timezone,
                  )}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  options={TimeZone}
                  onChange={this.onTimezoneChange}
                  className={classnames({
                    'has-error':
                      this.state.mandatoryFieldBlankError && !this.state.timezone,
                  })}
                  name="timezone"
                  disabled={isSwConnected}
                />
              </div>
            </section>

            {/* Separator goes here */}

            {currentDomain === DENTAL ? null : (
              <section className="authorize-access__sw-details">
                <p className="authorize-access__text">
                  Please create a staff login on your {bookingSoftware} software
                  for TrueLark to use and enter those here
                </p>

                <div className="authorize-access__form__row form-group">
                  <p className="form-group__heading">Booking Software URL</p>
                  <input
                    type="text"
                    name="site_link"
                    className={classnames({
                      'has-error':
                        (this.state.mandatoryFieldBlankError &&
                          !this.state.site_link) ||
                        this.state.invalidURLError,
                    })}
                    value={this.state.site_link}
                    onChange={this.onInputChange}
                    autoComplete="false"
                    disabled={isSwConnected}
                  />
                </div>

                <div className="authorize-access__form__row form-group">
                  <p className="form-group__heading">Login</p>
                  <input
                    type="text"
                    name="otherUsername"
                    className={classnames({
                      'has-error':
                        this.state.mandatoryFieldBlankError &&
                        !this.state.otherUsername,
                    })}
                    value={this.state.otherUsername}
                    onChange={this.onInputChange}
                    autoComplete="false"
                    placeholder="TrueLark"
                    disabled={isSwConnected}
                  />
                </div>

                <div className="authorize-access__form__row form-group">
                  <p className="form-group__heading">Password</p>
                  <input
                    type="text"
                    name="otherPassword"
                    className={classnames({
                      'has-error':
                        this.state.mandatoryFieldBlankError &&
                        !this.state.otherPassword,
                    })}
                    value={this.state.otherPassword}
                    onChange={this.onInputChange}
                    autoComplete="false"
                    placeholder="fdai_zipcode-last-4-digits"
                    disabled={isSwConnected}
                  />
                </div>
              </section>
            )}

            {currentDomain === DENTAL ? (
              <div className="authorize-access__form__row form-group">
                <p className="form-group__heading">Booking Software</p>
                <Select
                  value={bookingSoftwaresList.filter(
                    (option) => option.value === this.state.bookingSoftware,
                  )}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  options={bookingSoftwaresList}
                  onChange={this.onBookingSoftwareChange}
                  className={classnames({
                    'has-error':
                      this.state.mandatoryFieldBlankError &&
                      !this.state.bookingSoftware,
                  })}
                  name="bookingSoftware"
                  disabled={isSwConnected}
                />
              </div>
            ) : null}

            {currentDomain === DENTAL &&
            this.state.bookingSoftware === 'ADDNEW' ? (
              <div className="authorize-access__form__row form-group">
                <p className="form-group__heading">Add New Booking Software</p>
                <input
                  type="text"
                  name="otherBookingSoftware"
                  className={classnames({
                    'has-error':
                      this.state.mandatoryFieldBlankError &&
                      !this.state.otherBookingSoftware,
                  })}
                  value={this.state.otherBookingSoftware}
                  onChange={this.onInputChange}
                  autoComplete="false"
                  disabled={isSwConnected}
                />
              </div>
            ) : null}
          </form>
          <div className="authorize-access__actions">
            <button
              className="btn btn--secondary btn--lg"
              type="button"
              onClick={this.props.onBackClick}
            >
              Previous
            </button>
            <button
              className="btn btn--primary btn--lg"
              onClick={this.onNextButtonClick}
              disabled={((!enableNextButtonForBSWs.includes(this.state.bookingSoftware)) && (isSwConnected || isSaving))}
            >
              {isSaving ? 'Saving...' : 'Next'}
            </button>
          </div>
        </div>
      );
    }
  }
}

NonIntegratedSoftwareAuthorization.defaultProps = {
  postBookingSoftwareRequest: () => {},
  onBackClick: () => {},
  currentDomain: '',
  softwares: {
    otherUsername: '',
    otherPassword: '',
  },
};

NonIntegratedSoftwareAuthorization.propTypes = {
  postBookingSoftwareRequest: PropTypes.func,
  onBackClick: PropTypes.func,
  currentDomain: PropTypes.string,
  softwares: PropTypes.shape({
    selectedSoftware: PropTypes.string,
    info: PropTypes.shape({
      STUDIO_NAME: PropTypes.string,
      STUDIO_LOCATION: PropTypes.string,
      accountName: PropTypes.string,
      URL: PropTypes.string,
    }),
    otherUsername: PropTypes.string,
    otherPassword: PropTypes.string,
  }),
  business: PropTypes.shape({
    info: PropTypes.shape({
      TIMEZONE: PropTypes.string,
    }),
  }).isRequired,
  dashboard: PropTypes.shape({
    tasksStatus: PropTypes.shape({
      bookingSW_connect: PropTypes.string,
    }),
  }).isRequired,
};
